const GoogleLogo = ({ className }: { className: string }) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M22.5045 12.2326C22.5045 11.3693 22.433 10.7393 22.2783 10.0859H12.2188V13.9826H18.1235C18.0045 14.9509 17.3616 16.4093 15.933 17.3892L15.913 17.5197L19.0936 19.9344L19.314 19.9559C21.3377 18.1242 22.5045 15.4292 22.5045 12.2326Z"
        fill="#4285F4"
      />
      <path
        d="M12.212 22.5015C15.1048 22.5015 17.5334 21.5682 19.3072 19.9582L15.9263 17.3914C15.0215 18.0098 13.8072 18.4414 12.212 18.4414C9.37874 18.4414 6.974 16.6098 6.11678 14.0781L5.99113 14.0886L2.68388 16.5969L2.64062 16.7148C4.4025 20.1448 8.02155 22.5015 12.212 22.5015Z"
        fill="#34A853"
      />
      <path
        d="M6.119 14.0755C5.89281 13.4222 5.76191 12.7221 5.76191 11.9988C5.76191 11.2754 5.89281 10.5755 6.1071 9.92215L6.10111 9.78301L2.75239 7.23438L2.64283 7.28545C1.91667 8.7088 1.5 10.3072 1.5 11.9988C1.5 13.6905 1.91667 15.2888 2.64283 16.7121L6.119 14.0755Z"
        fill="#FBBC05"
      />
      <path
        d="M12.2121 5.55997C14.224 5.55997 15.5811 6.41163 16.3549 7.12335L19.3787 4.23C17.5216 2.53834 15.1049 1.5 12.2121 1.5C8.02158 1.5 4.40251 3.85665 2.64062 7.28662L6.1049 9.92332C6.97403 7.39166 9.37878 5.55997 12.2121 5.55997Z"
        fill="#EB4335"
      />
    </svg>
  );
};

export default GoogleLogo;
